export default {
  setMigrationDialogHeader: 'Set start of migration',
  setMessage: 'Are you sure you want to reset the migration status for {count} {type}?\n'
    + 'As a consequence all {type} will be migrated from the {date}.',
  setMigrationDialogErrorPast: 'The date must be in the past',
};
